mx.plugin.metadataDrivenField = function(attributeName, config) {
    this.attributeName = attributeName;
    Ext.apply(this, config);
};
Ext.extend(mx.plugin.metadataDrivenField, Ext.util.Observable, {
    attributeName: null,
    dataType: 'string',
    init: function(component) {
        component.switchedOn = true;
        component.isMetadataDriven = function() {
            return true;
        };
        component.getAttributeName = function() {
            return this.attributeName;
        }.createDelegate(this);

        component.switchOn = this.switchOn.createDelegate(component);
        component.switchOff = this.switchOff.createDelegate(component);
        component.isSwitchedOn = this.isSwitchedOn.createDelegate(component);
        component.convertValueFromServer = this.convertValueFromServer.createDelegate(this);
    },
    convertValueFromServer: function(v) {
        if (this.dataType == 'date') {
            return new Date(v * 1);
        } else {
            return v;
        }
    },
    switchOn: function() {
        this.switchedOn = true;
    },
    switchOff: function() {
        this.switchedOn = false;
    },
    isSwitchedOn: function() {
        return this.switchedOn;
    },
});
